<h2 class="mb-3">
  {{
    ((isLive$ | async)
      ? 'subscriptionManagement.cancelSubscription.cancelYourSubscriptionAreYouSure'
      : 'subscriptionManagement.cancelSubscription.resetDemoAreYouSure'
    ) | transloco
  }}
</h2>
<yat-subscription-cancel id="299f9bbf-7a05-47c0-a6d1-6e56b3262cfc"
  (cancelSubscriptionMethod)="cancelSubscription()"
  (backMethod)="back()"
  [endOfPeriod]="endOfPeriod$ | async"
  [terminationDate]="terminationDate$ | async"
  [endOfNoticePeriod]="endOfNoticePeriod$ | async"
  [productName]="(product$ | async)?.productLocalization?.productName"
  [liveLicense]="(isLive$ | async) ?? true"
  buttonsClassName="btn-large">
</yat-subscription-cancel>
